import { render } from "./RoleStatus.vue?vue&type=template&id=5966345e"
import script from "./RoleStatus.vue?vue&type=script&lang=js"
export * from "./RoleStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__